export type ValidationError = {
  valid?: string
  invalid?: string
}

export type FormErrors = {
  propertyValue: ValidationError
  loanAmount: ValidationError
  state: ValidationError
}

export enum ProspectPersonType {
  NATURAL_PERSON = 'NATURAL_PERSON',
  LEGAL_PERSON = 'LEGAL_PERSON'
}

export type FormValues = {
  propertyValue: string
  loanAmount: string
  state: string
  personType: ProspectPersonType
}
